import React from 'react';
import { useListMaps } from './useListMaps';
import { StateView } from '../../common/StateView';
import {
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Link,
  Button,
} from '@chakra-ui/react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toUrl, createRoute } from '../../../util/routes';
import { useNavigate } from 'react-router';
import { useDeleteMap } from '../../../service/requests';

export const Home: React.FC = StateView(useListMaps, ({ mapResult }) => {
  const navigate = useNavigate();
  const { deleteMap } = useDeleteMap();

  return (
    <>
      <Button
        onClick={() => {
          navigate(toUrl(createRoute('createMap')));
        }}
      >
        Create
      </Button>
      <Table size="sm" display={mapResult.length ? 'table' : 'none'}>
        <Thead>
          <Tr>
            <Th>Table Name</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {mapResult?.map((map) => {
            return (
              <Tr key={map.mapId}>
                <Td>
                  <Link
                    onClick={() => {
                      navigate(
                        toUrl(createRoute('viewMap', { mapId: map.mapId })),
                      );
                    }}
                  >
                    {map.name}
                  </Link>
                </Td>
                <Td>
                  <FontAwesomeIcon
                    onClick={() => deleteMap({ mapId: map.mapId })}
                    size="lg"
                    icon={faTrash}
                    color="#ff575c"
                    style={{ cursor: 'pointer' }}
                  />
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </>
  );
});
